import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';

import appSettings from './mixins/config/appSettings'
// Import the Auth0 configuration
//import { domain, clientId } from "../auth_config.json";
export const DOMAIN  = appSettings.data().appSettings.AUTH0_DOMAIN;
export const CLIENT_ID = appSettings.data().appSettings.AUTH0_CLIENT_ID;
export const AUDIENCE = appSettings.data().appSettings.AUTH0_AUDIENCE;

// Import the plugin here
//import { Auth0Plugin } from "./auth/auth0";
import {SanctumAuthPlugin} from "@/auth/sanctum";
import {WorkSessionsPlugin} from "@/workSessions"
//Sanitize html!
import sanitizeHTML from 'sanitize-html';

Vue.prototype.$sanitize = sanitizeHTML;

/*console.log("AUDIENCE");
console.log(AUDIENCE);*/
// Install the authentication plugin here
/*Vue.use(Auth0Plugin, {
  "domain": DOMAIN,
  "clientId" : CLIENT_ID,
  "audience" : AUDIENCE,
  "response_type" : 'id_token token',
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});*/

Vue.use(SanctumAuthPlugin, router);
Vue.use(WorkSessionsPlugin);

Vue.config.productionTip = false

vuetify.theme =  {
      primary: "#FFCC33",//appSettings.data().appSettings.colors.primary,
      secondary: appSettings.data().appSettings.colors.secondary,
      accent: appSettings.data().appSettings.colors.accent
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')